import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import * as _ from "lodash";

import { CustomerService } from "../../services/customer.service";
import { EmployeeService } from "../../services/employee.service";
import { PersonService } from "../../services/person.service";
import { ProjectService } from "../../services/project.service";
import { SupplierService } from "../../services/supplier.service";

@Component({
  selector: "ngx-dialog-link-object",
  templateUrl: "dialog-link-object.component.html",
  styleUrls: ["dialog-link-object.component.scss"],
})
export class DialogLinkObjectComponent implements OnInit {
  @Input() header: string;
  @Input() shopId?: string;
  @Input() objectType?: string = ""; //customer/supplier/employee/user
  @Input() linkObjectId: string;
  @Input() objects: any[] = [];
  @Input() allowCreate?: boolean = true;

  diaForm: FormGroup;
  loading = false;
  submitted = false;
  strSearch = "";
  mobile = "";

  page: number = 1;
  display?: any[] = [];

  constructor(
    protected ref: NbDialogRef<DialogLinkObjectComponent>,
    private fb: FormBuilder,
    private personService: PersonService,
    private customerService: CustomerService,
    private supplierService: SupplierService,
    private employeeService: EmployeeService,
    private projectService: ProjectService,
  ) {}

  ngOnInit() {
    const fullNameValidators = [
      Validators.minLength(1),
      Validators.maxLength(250),
      Validators.required,
    ];
    const mobileValidators = [];
    this.diaForm = this.fb.group({
      fullName: ["", fullNameValidators],
      mobile: ["", mobileValidators],
    });
  }

  cancel() {
    this.ref.close();
  }

  //Create
  create() {
    let cus = {
      shopId: this.shopId,
      fullName: this.strSearch.trim(),
      mobile: this.mobile.trim(),
    };

    this.loading = true;
    this.submitted = true;

    let subscription;
    switch (this.objectType) {
      case "customer":
        subscription = this.customerService.create(cus);
        break;
      case "supplier":
        subscription = this.supplierService.create(cus);
        break;
      case "employee":
        subscription = this.employeeService.create(cus);
        break;
      case "project":
        let pro = {
          shopId: this.shopId,
          title: this.strSearch.trim(),
        };
        subscription = this.projectService.create(pro);
        break;
      case "person":
        subscription = this.personService.create(cus);
        break;

      default:
        subscription = null;
        break;
    }

    if (subscription) {
      subscription
        .then((data) => {
          this.selected(JSON.parse(JSON.stringify(data)));
        })
        .catch((err) => {
          this.loading = false;
          this.submitted = false;
        });
    }
  }

  selected(item) {
    this.submitted = true;
    this.ref.close(item);
  }

  removeLink() {
    this.submitted = true;
    const value = {
      id: "",
    };
    this.ref.close(value);
  }

  pageChange(page: number) {
    this.page = page;
  }

  onSearch(): void {
    this.page = 1;

    const strFilter = this.strSearch.toLowerCase();
    console.log("onSearch", strFilter);

    this.loading = true;
    if (!strFilter || strFilter === "") {
      this.display = [...this.objects];
      this.loading = false;
    } else {
      this.display = _.filter(this.objects, function (item) {
        const title = item.fullName
          ? item.fullName.toLowerCase()
          : item.title
            ? item.title.toLowerCase()
            : "";
        const mobile = item.mobile ? item.mobile.toLowerCase() : "";
        const address = item.address ? item.address.toLowerCase() : "";
        const cardId = item.cardId ? item.cardId.toLowerCase() : "";
        const taxCode = item.tax ? item.tax.toLowerCase() : "";

        return (
          (title && title.includes(strFilter)) ||
          (address && address.includes(strFilter)) ||
          (cardId && cardId.includes(strFilter)) ||
          (mobile && mobile.includes(strFilter)) ||
          (taxCode && taxCode.includes(strFilter))
        );
      });
    }
    this.loading = false;
  }
}
